// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, FieldValue } from "firebase/firestore";
import { getStorage } from "firebase/storage"
import { getAuth } from "firebase/auth";
import "firebase/compat/firestore";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyDr-Em1sb-JcOdPoTX-8hG_ILI5guTKvWQ",
	authDomain: "picboard-8df2c.firebaseapp.com",
	projectId: "picboard-8df2c",
	storageBucket: "picboard-8df2c.appspot.com",
	messagingSenderId: "595836118558",
	appId: "1:595836118558:web:06340161045c88cc7d700f",
	measurementId: "G-VHMGRBH8S3"
};


// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();
const firestore = getFirestore(app);

const storage = getStorage(app);
//connectAuthEmulator(auth, "http://localhost:9099");
export { app, analytics, auth , firestore , storage, FieldValue};
